import { ApiProperty } from "@nestjs/swagger";

class ParamChild {
    @ApiProperty()
    parameter: string
}

export class ParameterDto {
    @ApiProperty()
    id: number

    @ApiProperty()
    paramId: number

    @ApiProperty()
    parameters: ParamChild[]

    @ApiProperty()
    buyer: string;
}
